

import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AmbassadorsProfileService } from 'src/app/services/ambassadors-profile.service';
import { LookupsService } from 'src/app/services/lookups.service';
import { Lookup } from 'src/app/models/lookups/Lookup';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { WorkExperiencesFormComponent } from './work-experiences-form/work-experiences-form.component';
import { AmbassadorWorkExperience } from 'src/app/models/user/AmbassadorWorkExperience';
@Component({
  selector: 'app-work-experiences',
  standalone: false,
  templateUrl: './work-experiences.component.html'
})
export class WorkExperiencesComponent implements OnInit {
  @Input() canModify!:boolean;
  @Input() userId!:any;
  formGroup!: FormGroup;
  showModal = false
  dataLoading = false
  dataSource: AmbassadorWorkExperience[] = []

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private service: AmbassadorsProfileService,
    private lookupsService: LookupsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getAll()
  }


  getAll() {
    this.dataLoading = true;
    const params = this.userId ? { userId: this.userId } : {};
    this.service.GetAmbassadorWorkExperience(params).subscribe((response: any) => {
      this.dataLoading = false;
      this.dataSource = response as AmbassadorWorkExperience[];
    }, err => {
      this.dataLoading = false
    })
  }

  openForm(record: any = null) {
    const dialogRef = this.dialog.open(WorkExperiencesFormComponent, {
      width: '550px',
      data: { record },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAll();
      }
    });

  }





  deleteRecord(id: number) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.service.DeleteAmbassadorWorkExperience(id).subscribe(
          (data: any) => {
            Swal.fire({
              title: this.translate.instant('swalMsg.deletededsuccessfuly'),
              icon: 'success',
              confirmButtonText: this.translate.instant('swalMsg.ok')
            });
            this.getAll();
          }, (error: any) => {
            console.error(error);
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: this.translate.instant('swalMsg.FailedText'),
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.ok')
            });
          });
      }
    });
  }


}

